import { type HTMLAttributes, type ReactNode } from "react";
import { cn } from "../../lib/cn";

export function EmptyState({
  action,
  as: Heading = "h2",
  icon,
  title,
  message,
  compact = false,
  className,
  emphasis = "default",
  layout = "stacked"
}: {
  action?: ReactNode;
  as?: "h2" | "h3";
  icon: ReactNode;
  title: string;
  message?: string;
  compact?: boolean;
  className?: string;
  emphasis?: "default" | "prominent" | "hero";
  layout?: "stacked" | "inline";
}) {
  return (
    <div
      className={cn(
        "ui-empty-state",
        emphasis === "hero" && "ui-empty-state-hero",
        emphasis === "prominent" && "ui-empty-state-prominent",
        layout === "inline" && "ui-empty-state-inline",
        compact && "ui-empty-state-compact",
        action && "ui-empty-state-with-action",
        className
      )}
    >
      <span className="ui-empty-state-icon" aria-hidden="true">
        {icon}
      </span>
      <span className="ui-empty-state-copy">
        <Heading className="ui-empty-state-title">{title}</Heading>
        {message && <p>{message}</p>}
      </span>
      {action && <span className="ui-empty-state-action">{action}</span>}
    </div>
  );
}

export function EmptyNote({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn("ui-empty-note", className)} {...props} />;
}
